import { Dispatch, SetStateAction, useEffect, useRef } from 'react';

interface IProps {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  note: string;
  setNote: Dispatch<SetStateAction<string>>;
  onChange: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  submit: () => void;
}

const QuarantineStatusNotesModal = ({
  isOpen,
  setIsOpen,
  note,
  setNote,
  onChange,
  submit,
}: IProps) => {
  const modalRef = useRef<HTMLDivElement>(null);
  const instanceRef = useRef<M.Modal | null>(null);

  useEffect(() => {
    if (!modalRef.current) return;

    instanceRef.current = M.Modal.init(modalRef.current, {
      onCloseEnd: () => setIsOpen(false),
      dismissible: false,
    });

    return () => {
      instanceRef.current?.destroy();
      instanceRef.current = null;
    };
  }, [setIsOpen]);

  useEffect(() => {
    const instance = instanceRef.current;
    if (!instance) return;

    if (isOpen) {
      instance.open();
    } else {
      instance.close();
    }
  }, [isOpen]);

  return (
    <div ref={modalRef} className="modal">
      <div className="modal-content">
        <h3 style={{ textAlign: 'center' }}>
          Would you like to add a note to the status?
        </h3>
        <div className="input-field col s12 m3 l2">
          <textarea id="note" name="note" value={note} onChange={onChange} />
          <label htmlFor="note">Note</label>
        </div>
        <div className="row">
          <button
            className="btn-small green waves-effect waves-dark col s3 offset-m2 m3 "
            onClick={() => {
              submit();
              setIsOpen(false);
              setNote('');
            }}
          >
            Submit
          </button>
          <button
            className="btn-small red waves-effect waves-dark col s3 offset-m2 m3 "
            onClick={() => instanceRef.current?.close()}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuarantineStatusNotesModal;
